module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_chapel@3x-c96266dce14f5f57b2f334152c79c774.webp";